import React, { useRef } from "react";
import { Container, ImgBox, TextBox, Wrapper } from "./style";
import { useTranslation } from "react-i18next";
import { useScrollFadeIn } from "hooks/useScrollFadeIn";
const Com1 = () => {
  const { t } = useTranslation("comingSoon");
  const ref1 = useRef();
  useScrollFadeIn(ref1);
  return (
    <Wrapper>
      <Container ref={ref1} className="fade-in">
        <ImgBox>
          <img
            src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/8e8564c9SketchScan.png"
            alt="스케치 스캔 준비중"
          />
        </ImgBox>
        <TextBox>
          <span>{t("1-1")}</span>
          <div>
            <span>{t("1-2")}</span>
            <span>{t("1-3")}</span>
          </div>
        </TextBox>
      </Container>
    </Wrapper>
  );
};

export default Com1;
